import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import { ICONS } from 'constants/icons';
import { reduxFormPropTypes } from 'constants/propTypes';
import Button from 'components/Button';
import { DateInput, InputError, InputLabel } from 'components/Form';
import Message from 'components/Message';
import messages from '../../ScheduleForm.messages';
import './SingleDayExceptions.scss';

const { block, element } = bem('schedule-single-day-exceptions');

const SingleDayExceptions = ({ fields, meta: { error }, nextSingleDayExceptionDate }) => {
  const handleRemove = idx => () => fields.remove(idx);
  const handlePush = () =>
    fields.push((nextSingleDayExceptionDate && nextSingleDayExceptionDate.toISOString()) || new Date().toISOString());
  return (
    <div className={block()}>
      <InputLabel message={messages.singleDayExceptions} />
      {fields.map((field, idx) => (
        <div className={element('row')} data-cypress={`single-day-exception-${idx}`} key={field}>
          <Field name={field} component={DateInput} />
          <Button className={element('cross-button')} styled={false} onClick={handleRemove(idx)}>
            <Isvg src={ICONS.crossSmall} />
          </Button>
        </div>
      ))}
      <InputError error={error} />
      <Message
        as="button"
        data-cypress="add-exception-day-button"
        className={element('add-new')}
        onClick={handlePush}
        message={messages.addSingleDayException}
      />
    </div>
  );
};

SingleDayExceptions.propTypes = {
  fields: reduxFormPropTypes.fieldArray.fields,
  meta: PropTypes.shape({
    error: PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
  }),
  nextSingleDayExceptionDate: PropTypes.instanceOf(Date),
};

export default SingleDayExceptions;
